import { useAppContext } from '@/AppContext'
import MicrophoneOffIcon from '@/CustomIcons/MicrophoneOffIcon'
import { AnalyticsEvents } from '@/services/AnalyticsService'
import useAnalytics from '@/services/useAnalytics'
import { Slider } from '@/UIComponents2/Slider'
import { useState } from 'react'
import { Card } from '../../Card'
import { CardHeader } from '../../CardHeader'

export function AutoMuteSection() {
    const [appState, appDispatch] = useAppContext()
    const { logUserActivityWithContext } = useAnalytics()
    const [threshold, setThreshold] = useState(appState.appSettings.autoMuteThreshold)
    const [attack, setAttack] = useState(appState.appSettings.autoMuteAttackMs)
    const [release, setRelease] = useState(appState.appSettings.autoMuteReleaseMs)

    const sliderClasses = 'max-w-[400px] justify-self-end'

    return (
        <Card className="flex flex-col gap-[20px]">
            <CardHeader icon={MicrophoneOffIcon} title="Auto Mute" />
            <div className="grid grid-cols-[min-content_1fr_50px] gap-y-[35px] gap-x-[20px] pt-4">
                <div className="whitespace-nowrap">Activation Threshold</div>
                <Slider
                    markers={false}
                    min={0.1}
                    max={1.0}
                    step={0.05}
                    onChange={(v) => setThreshold(v)}
                    initialValue={appState.appSettings.autoMuteThreshold}
                    onChangeEnd={(v) => {
                        appDispatch({
                            type: 'update_app_settings',
                            value: { autoMuteThreshold: v },
                        })
                        logUserActivityWithContext(AnalyticsEvents.CHANGED_AUTO_MUTE_THRESHOLD, {
                            autoMuteThreshold: v,
                        })
                    }}
                    className={sliderClasses}
                />
                <div className="t-base-light">{threshold.toFixed(2)}</div>

                <div className="whitespace-nowrap">Attack</div>
                <Slider
                    markers={false}
                    min={50}
                    max={1000}
                    step={50}
                    onChange={(v) => setAttack(v)}
                    initialValue={appState.appSettings.autoMuteAttackMs}
                    onChangeEnd={(v) => {
                        appDispatch({
                            type: 'update_app_settings',
                            value: { autoMuteAttackMs: v },
                        })
                        logUserActivityWithContext(AnalyticsEvents.CHANGED_AUTO_MUTE_ATTACK, {
                            autoMuteAttackMs: v,
                        })
                    }}
                    className={sliderClasses}
                />
                <div className="t-base-light">{attack}ms</div>

                <div className="whitespace-nowrap">Release</div>
                <Slider
                    markers={false}
                    min={50}
                    max={1000}
                    step={50}
                    onChange={(v) => setRelease(v)}
                    initialValue={appState.appSettings.autoMuteReleaseMs}
                    onChangeEnd={(v) => {
                        appDispatch({
                            type: 'update_app_settings',
                            value: { autoMuteReleaseMs: v },
                        })
                        logUserActivityWithContext(AnalyticsEvents.CHANGED_AUTO_MUTE_RELEASE, {
                            autoMuteReleaseMs: v,
                        })
                    }}
                    className={sliderClasses}
                />
                <div className="t-base-light">{release}ms</div>
            </div>
        </Card>
    )
}
